import React from "react";
import {Box, Column, Columns, Table, Title} from "@allxsmith/bestax-bulma";
import InvoiceSectionRow from "./InvoiceSectionRow";


export default function InvoiceSection({invoices}){


    return (
        <Box>
            <details>
                <summary><Title>Invoices</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Table isFullwidth>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Quantity</th>
                                <th>Amount</th>
                                <th>No Vat Amount</th>
                                <th>Invoice Date</th>
                                <th>Invoice Number</th>
                                <th>Approved</th>
                                <th>Approver</th>
                                <th>Description</th>
                                <th>Comments</th>
                                <th>Hidden</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.map(invoice => (
                                <InvoiceSectionRow
                                    invoice={invoice}
                                />
                            ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}